import { JVInputCheck } from "../../shared/JVInputCheck";
import { yupResolver } from "@hookform/resolvers/yup";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { Fetch } from "../../shared/Fetch";
import { IClientDetail } from "./ClientTnfr";
import { Table } from "./Table";
import { Button } from "primereact/button";
import { Form } from "../requirement/sales/Form";
import { EmptyRequirement } from "../requirement/EmptyRequirement";
import { IPermissionProps } from "../../models/Login";
import Confetti from 'react-confetti';
import TextTransition, { presets } from "react-text-transition";
import { ILogin } from "../../models/Login";

const emailSchema = yup.object().shape({
    email: yup.string().required("contact person email_id is required*").email("contact person email_id must be a valid email*")
});

export const ClientTransfer = (permissions: IPermissionProps) => {
    const [tableData, setTableData] = useState<IClientDetail>();
    const [loading, setLoading] = useState(false);
    const [form, setForm] = useState({ cpid: 0, open: false });
    const toast: any = useRef();
    const { control, handleSubmit, formState: { errors }, reset } = useForm<{ email: string | undefined }>({
        resolver: yupResolver(emailSchema),
        defaultValues: {},
        shouldFocusError: false
    });

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const [celebrate, setCelebrate] = useState<boolean>(false);
    const [index, setIndex] = useState(0);

    const TEXTS = ["You", "Did", "It!"];

    const colors = ["#ff595e", "#d1d646", "#edae49"];

    useEffect(() => {
        const intervalId = setInterval(
            () => setIndex((index) => index + 1),
            3000
        );
        return () => clearTimeout(intervalId);
    }, []);

    const ShowCelebration = () => {
        setCelebrate(true); setTimeout(() => setCelebrate(false), 10000);
    }

    const checkEmail = async () => {
        setLoading(true);
        const valid = await emailSchema.isValid({
            email: control._formValues.email,
        });
        if (valid) {
            const response = await Fetch("Sub_Vendor_Contact_Person_Mast/clienttnfr", "GET", null, `email=${control._formValues.email}`, toast);
            if (response) {
                const data: IClientDetail = (await response.json())[0];
                setTableData(data);
            }
        } else {
            toast.current.show({ severity: 'error', summary: "Please Enter a Valid Email", life: 3000 });
        }
        setLoading(false);
    }

    const clientTransfer = async (email: string) => {
        setLoading(true);
        const response = await Fetch("Sub_Vendor_Contact_Person_Mast/clienttnfr", "POST", null, `email=${email}`, toast);
        if (response) {
            const data: { contact_Person_ID: number } = await response.json();
            setForm({ cpid: data.contact_Person_ID, open: true });
        }
        setLoading(false);
    }

    function onSubmit(data: { email: string | undefined }) {
        if (data.email && tableData) clientTransfer(data.email);
    }

    useEffect(() => {
        if (loginObj.website_Settings.enable_Add_Req_Time == true) {
            const st = new Date();
            st.setHours(8, 55, 0, 0);
            const et = new Date();
            et.setHours(18, 0, 0, 0);
            const currentTime = new Date();
            if (currentTime < st || currentTime > et) {
                toast.current.show({ severity: 'error', detail: "You can post the requirements between 8:55 AM to 6:00 PM", life: 3000 });
            }
        }
    }, []);

    const st = new Date();
    st.setHours(8, 55, 0, 0);
    const et = new Date();
    et.setHours(18, 0, 0, 0);
    const currentTime = new Date();

    return (<>
        {
            ((loginObj.website_Settings.enable_Add_Req_Time == true && currentTime >= st && currentTime <= et) || loginObj.website_Settings.enable_Add_Req_Time !== true) && <form onSubmit={handleSubmit(onSubmit)}>
                <JVInputCheck func={checkEmail} label="Contact Person Email ID" control={control} name="email" error={errors.email?.message} />
                {loading && <h3 className="ml-3">Loading...</h3>}
                {tableData && <><Table data={tableData} />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1rem' }}>
                        <Button label="Client Transfer" type="submit" loading={loading}></Button>
                    </div></>}
            </form>}
        <Form singleData={{ ...EmptyRequirement, pV_Contact_PersonID: form.cpid }} open={form.open} toast={toast} ShowCelebration={ShowCelebration} reqFrom={'ClientTransfer'}></Form>
        <Toast ref={toast} />
        {celebrate && (
            <Confetti
                width={window.innerWidth}
                height={window.innerHeight}
                gravity={0.2}

            />
        )}
        <div style={{ position: "absolute", top: '50%', left: '50%', transform: " translate(-50%, -50%)" }}>
            {celebrate && (
                <TextTransition className="m-6 " style={{ color: colors[index % colors.length], alignContent: "center" }} springConfig={presets.wobbly}><h1 style={{ fontSize: '124px', alignContent: "center", marginLeft: "40px" }}>{TEXTS[index % TEXTS.length]}&#127881;</h1></TextTransition>
            )}
        </div>
    </>
    );
}